import {LicenseInfo} from '@mui/x-license';
import type React from "react";

LicenseInfo.setLicenseKey('71463dbd7e83dca1a5b781eea2f5801aTz0xMTk3NzAsRT0xNzkwODEyNzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

// This component ensures the license key is set as early as possible
export const MuiXLicense: React.FC = () => null
